import React from "react";
import styled from "styled-components";
import {subduedTextColour} from "../../../../style/styleConsts";

const Container = styled.div`
    color: ${subduedTextColour};
    margin-left: 14px;
    margin-top: 11px;
`;

const NotAvailableMessage = () => (
    <Container>Not yet available.</Container>
);

export default NotAvailableMessage;